module.exports = __webpack_public_path__ + "static/img/icons8-ok.25239c7d.svg";